module.exports = __webpack_public_path__ + "static/media/categories_step_2_3.eee63fc3.svg";